import { useState } from 'react'

function defaultValidate() {
  return {}
}

export default function useForm(opts) {
  const { validate = defaultValidate } = opts

  const [inputs, setInputs] = useState(opts.initialState || {})
  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [pristine, setPristine] = useState(true)

  function dispatchInputs(values) {
    const newInputs = Object.assign(Object.assign({}, inputs), values)
    setInputs(newInputs)
    if (pristine) {
      setPristine(false)
    }
    if (submitted) {
      setErrors(validate(newInputs))
    }
  }

  return {
    dispatchInputs,
    errors,
    inputs,
    pristine,
    submitted,
    setSubmitted,
    onSubmit(event) {
      event.preventDefault()
      setSubmitted(true)
      const newErrors = validate(inputs)
      setErrors(newErrors)
      if (Object.keys(newErrors).length === 0) {
        setPristine(true)
        opts.onSuccessSubmit(inputs)
      }
    },
    onChange(event) {
      dispatchInputs({ [event.target.name]: event.target.value })
    },
    onChangeRadio(event, value) {
      const target = event.target
      dispatchInputs({ [target.name]: value })
    },
  }
}
